/** No-op `.catch` for `react-full-screen` enter/exit Promise rejections (e.g. `Document not active`). Upstream-endorsed remediation — see https://github.com/snakesilk/react-fullscreen/issues/48. */
export const silenceFullscreenError = (): void => {};
